/** Errors raised by third-party code that runs our pages, never by Lopaka itself. */
export const SENTRY_IGNORED_ERRORS = [
    // Outlook Safe Links opens emailed links in Microsoft's scanner browser, whose bridge rejects with this value.
    /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
];
